import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import { GlobalMessage } from './entities/globalMessage';
import { GlobalLoading } from './entities/globalLoading';
import { useAppSelector } from './app/store/store';
import { useEffect, useRef, useState } from 'react';
import { FEATURES, IMy, hasFeature, myService, useMyActions } from './entities/my';
import { AUTH_ROUTE, STUDENT_PAYMENT_ROUTE } from './app/router/routes';
import { LoaderSpinner } from './shared/ui/spinner';
import { ReceiptPending } from './widgets/receiptPending';

function App() {

  const {isLoading: globalIsLoading} = useAppSelector(s => s.globalLoadingReducer)
  const {globalMessage} = useAppSelector(s => s.globalMessageReducer)
  const {pathname} = useLocation()
  const paymentPublicPath = STUDENT_PAYMENT_ROUTE.path.replace(':hash', '')
  const isPublicPage = pathname.startsWith(paymentPublicPath) || pathname === "/spasibo"
  const [isLoading, setIsLoading] = useState<boolean>(!isPublicPage)
  const {setId, setRole, setRoleName, setFullName, setIsAuth, setAvailableFeatures, setFeatureGrants} = useMyActions()
  const {my} = useAppSelector(s => s.myReducer)

  const router = useNavigate()

  const isOne = useRef<boolean>(true)
  useEffect(() => {
    if(isOne.current){
      isOne.current = false;
      return
    }
    if(!my.isAuth){
      router(AUTH_ROUTE.path)
    }
  }, [my.isAuth])

  useEffect(() => {
    window.scrollTo({top: 0})
  }, [pathname])

  const auth = async () => {
    try{
      setIsLoading(true)
      const {user, availableFeatures, featureGrants} = await myService.getInfo()
      setId(user.id)
      setRole(user.role)
      setRoleName(user.role_name)
      setFullName(user.full_name)
      setAvailableFeatures(availableFeatures)
      setFeatureGrants(featureGrants)
      setIsAuth(true)
    } 
    catch(e){
      router(AUTH_ROUTE.path) 
      console.log(e)
    }
    finally{
      setTimeout(() => setIsLoading(false), 1)
    }
  }

  useEffect(() => {
    if(process.env.REACT_APP_USE_AUTH === "false"){
      process.env.REACT_APP_ROLE && setRole(process.env.REACT_APP_ROLE as IMy['role'])
      process.env.REACT_APP_ID && setId(+process.env.REACT_APP_ID)
      process.env.REACT_APP_FULL_NAME && setFullName(process.env.REACT_APP_FULL_NAME)
      if(process.env.REACT_APP_AVAILABLE_FEATURES){
        const featureKeys = process.env.REACT_APP_AVAILABLE_FEATURES
            .split(',')
            .map(feature => feature.trim())
            .filter(Boolean)
        setAvailableFeatures(featureKeys)
        setFeatureGrants(featureKeys.map(featureKey => ({
          featureKey,
          targetUserIds: []
        })))
      }
      setIsAuth(true)
      setIsLoading(false)
    }
    else if(!isPublicPage){
      auth()
    }
  }, [])

  return (
    <div className="App">
      {
        isLoading
          ?
        <section className={"loader_main"}><LoaderSpinner /></section>
          :
        <>
          <Outlet />
          { globalMessage.message && <GlobalMessage /> }
          { globalIsLoading && <GlobalLoading /> }
          {my.isAuth && !isPublicPage && my.role === 'tutor' && hasFeature(my, FEATURES.TUTORS.PAYOUTS_READ, my.id) && <ReceiptPending />}
        </>
      }
    </div>
  );
}

export default App;
